import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { IVendorCustomerDto } from "../../../../dtos/catalogs/vendorcustomer/IVendorCustomerDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { VendorCustomerOperationTypeEnum } from "../../../../dtos/catalogs/vendorcustomer/VendorCustomerOperationTypeEnum";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFVendorCustomerCheckbox } from "../../../Shared/NewForms/NFVendorCustomerCheckbox";
import { NFLookupBankAccount } from "../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupCountry } from "../../../Shared/NewForms/NFLookupCountry";
import VendorCustomerDetailSkeleton from "./VendorCustomerDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";

interface IProps {
  model: IVendorCustomerDto | null;
  modelUpdatedEvent: (newModel: IVendorCustomerDto) => void;
}

interface VendorCustomerModel {
  id: string;
  name: string;
  description?: string;
  vatTaxable: boolean;
  tin?: string;
  vendorCustomerLegalForm: number;
  mainBankAccountId?: string;
  legalAddress?: string;
  uniqueCode?: string;
  createdDate?: Date;
  actualAddress?: string;
  phoneNumber?: string;
  email?: string;
  legalForm?: number;
  isEmailValidVendorCustomer: boolean;
  other?: string;
  additional?: string;
  countryId?: string;
  isCustomer: boolean;
  isVendor: boolean;
  isOther: boolean;
  vatTaxPayerId?: string;
  noVatTaxPayerId?: string;
  importAccountId?: string;
  exportId?: string;
  diplomatId?: string;
  reverseChargeVatId?: string;
  vatTaxableType?: number;
  downPaymentsAccountId?: string;
  settlementAccountId?: string;
}

export const VendorCustomerDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const { t } = useTranslation();
  const [selectVendor, setSeletVendor] = useState(false);
  const [selectCustomer, setSelectCustomer] = useState(false);

  const legalFormTypes = [
    {
      id: VendorCustomerOperationTypeEnum.IndividualEntity,
      name: t("IndividualEntity")
    },
    {
      id: VendorCustomerOperationTypeEnum.LimitedLiabilityCompany,
      name: t("LimitedLiabilityCompany")
    }
  ];

  const handleCustomerChange = (value: any) => {
    setSelectCustomer(value);
  };
  const handleVendorChange = (value: any) => {
    setSeletVendor(value);
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<VendorCustomerModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("vatTaxable", model.vatTaxable);
      setValue("tin", model.tin);
      setValue("uniqueCode", model.uniqueCode);
      setValue("vendorCustomerLegalForm", model.vendorCustomerLegalForm);
      setValue("mainBankAccountId", model.mainBankAccountId);
      setValue("legalAddress", model.actualAddress);
      setValue("legalForm", model.legalForm);
      setValue("actualAddress", model.name);
      setValue("phoneNumber", model.phoneNumber);
      setValue("email", model.email);
      setValue("isEmailValidVendorCustomer", model.isEmailValidVendorCustomer);
      setValue("other", model.other);
      setValue("additional", model.additional);
      setValue("countryId", model.countryId);
      setValue("isCustomer", model.isCustomer);
      setValue("isVendor", model.isVendor);
      setValue("isOther", model.isOther);
      setValue("vatTaxPayerId", model.vatTaxPayerId);
      setValue("createdDate", model.createdDate);
      setValue("noVatTaxPayerId", model.noVatTaxPayerId);
      setValue("importAccountId", model.importAccountId);
      setValue("exportId", model.exportId);
      setValue("diplomatId", model.diplomatId);
      setValue("vatTaxableType", model.vatTaxableType);
      setValue("reverseChargeVatId", model.reverseChargeVatId);

      setValue("downPaymentsAccountId", model.downPaymentsAccountId);
      setValue("settlementAccountId", model.settlementAccountId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: VendorCustomerModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: IVendorCustomerDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <VendorCustomerDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <div>
          <NFTabs
            onTabChange={(newIndex) => {
              setTabIndex(newIndex);
            }}
          >
            <NFTab title={"Main"} />
            <NFTab title={"Settings"} />
          </NFTabs>

          <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

          <Row>
            <Col sm={12}>
              <NFLookupInput title={"Legal Forms"} fieldName={"legalForm"} items={legalFormTypes} />
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div className={"d-flex"}>
                <NFVendorCustomerCheckbox title="Vendor" fieldName="isVendor" onValueChange={handleVendorChange} />
                <span className={"mx-3"}></span>
                <NFVendorCustomerCheckbox title="Customer" fieldName="isCustomer" onValueChange={handleCustomerChange} />
              </div>
            </Col>
          </Row>

          <NFTabContainer index={0} currentIndex={tabIndex}>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Name"} fieldName={"name"} />
              </Col>
              <Col sm={3}>
                <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
              </Col>
              <Col sm={3}>
                <NFDateInput title="Created Date" fieldName="createdDate" />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupBankAccount title="Main Bank Account" fieldName="mainBankAccountId" />
              </Col>
              <Col sm={6}>
                <NFLookupCountry fieldName="countryId" title="Country" />
              </Col>
            </Row>
          </NFTabContainer>

          <NFTabContainer index={1} currentIndex={tabIndex}>
            <Row>
              <Col sm={6}>
                <NFLookupAccount title={"Down payments Account"} fieldName={"downPaymentsAccountId"} />
              </Col>
              <Col sm={6}>
                <NFLookupAccount title={"Settlements Account"} fieldName={"settlementAccountId"} />
              </Col>
            </Row>
          </NFTabContainer>
        </div>
      </FormProvider>
    </>
  );
};
